import Alert from 'react-s-alert'
import FAIcon from './FAIcon'

import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import '../css/Alert.less'
import React, { Fragment } from 'react'

class FICAlert {
}

FICAlert.init = (container) => {
  FICAlert.container = ReactDOM.render(<Alert stack={{ limit: 4, spacing: 20 }} />, container)
}

FICAlert.show = (type, message, duration = 3000) => {
  // const successAlert = <FAIcon name="" />
  const mapping = {
    success: 'check-circle',
    error: 'exclamation-circle',
    warning: 'exclamation-triangle',
    info: 'info-circle'
  }
  const iconName = mapping[type]
  const customMessage = <Fragment>
    <div className='icon'><FAIcon name={iconName} /></div>
    <div className='text'>{message}</div>
  </Fragment>

  let options = {
    position: 'bottom-right',
    effect: 'slide',
    offset: 70,
    timeout: duration || 'none'
  }
  return Alert[type](customMessage, options)
}

FICAlert.success = (message, duration = 3000) => {
  return FICAlert.show('success', message, duration)
}

FICAlert.error = (message, duration = 5000) => {
  return FICAlert.show('error', message, duration)
}

FICAlert.warning = (message, duration = 3000) => {
  return FICAlert.show('warning', message, duration)
}

FICAlert.info = (message, duration = 5000) => {
  return FICAlert.show('info', message, duration)
}

FICAlert.close = (id) => {
  Alert.close(id)
}

FICAlert.closeAll = () => {
  Alert.closeAll()
}

export default FICAlert



// WEBPACK FOOTER //
// ./src/common/components/js/FICAlert.js